

























































import Vue from 'vue'
import { mapMutations } from 'vuex'
import AmataList from '@/components/AmataList.vue'
import AmataListItem from '@/components/AmataListItem.vue'
import UserActionMixin from '@/mixins/UserActionMixin'
import push from '@/push-notification'
import { sleep } from '@/utils/helpers'

export default Vue.extend({
  name: 'NotificationSetting',
  components: {
    'amata-list': AmataList,
    'amata-list-item': AmataListItem
  },
  mixins: [UserActionMixin],
  data() {
    return {
      initialized: false,
      disabledPushNotification: false,
      isFavOnry: this.$store.getters['NotificationSetting/msg_notice_from_favo'],
      isInfomation: this.$store.getters['NotificationSetting/msg_notice_from_site'],
      isMissedCalls: this.$store.getters['NotificationSetting/msg_notice_from_fuzai'],
      isIine: this.$store.getters['NotificationSetting/msg_notice_from_iine'],
      isNotifyApp: this.$store.getters['NotificationSetting/notice_by_app'],
      isNotifyMail: this.$store.getters['NotificationSetting/notice_by_mail'],
      // isSound: this.$store.getters['NotificationSetting/app_notice_sound'],
      // isVibration: this.$store.getters['NotificationSetting/app_notice_vib'],
      myEmail: '',
      pin: ''
    }
  },
  watch: {
    async isNotifyApp(this: any, val: number, from) {
      if (val === 1 && typeof from === 'number') {
        if (this.$_hasCordova) {
          push.initPushNotification(this.$root)
        } else {
          await sleep(500)
          this.$_tryLaunchApp('mypage')
        }
      }
    }
  },
  async created(this: any) {
    this.hasPermissionToPushNotification()

    // Active になる度にチェック
    this.$root.$on('resume', this.hasPermissionToPushNotification)

    const res = await this.$http.post('/notice_setting/', {
      page: 'get_init'
    })
    this.pin = res.data.pin
    this.isNotifyApp = parseInt(res.data.notice_by_app, 10)
    this.isNotifyMail = parseInt(res.data.notice_by_mail, 10)
    this.isFavOnry = parseInt(res.data.msg_notice_from_favo, 10)
    this.isInfomation = parseInt(res.data.msg_notice_from_site, 10)
    this.isMissedCalls = parseInt(res.data.msg_notice_from_fuzai, 10)
    this.isIine = parseInt(res.data.msg_notice_from_iine, 10)
    // this.isVibration = parseInt(res.data.app_notice_vib, 10)
    // this.isSound = parseInt(res.data.app_notice_sound, 10)
    this.myEmail = res.data.email
    this.set_notice_by_app(res.data.notice_by_app)
    this.set_notice_by_mail(res.data.notice_by_mail)
    this.set_msg_notice_from_favo(res.data.msg_notice_from_favo)
    this.set_msg_notice_from_site(res.data.msg_notice_from_site)
    this.set_msg_notice_from_fuzai(res.data.msg_notice_from_fuzai)
    this.set_msg_notice_from_fuzai(res.data.msg_notice_from_iine)
    // this.set_app_notice_vib(res.data.app_notice_vib)
    // this.set_app_notice_sound(res.data.app_notice_sound)
    setTimeout(() => {
      this.initialized = true
    }, 500)
  },
  destroyed(this: any) {
    if (this.$_platformIsIOS) {
      this.$root.$off('resume', this.hasPermissionToPushNotification)
    }
  },
  methods: {
    ...mapMutations('NotificationSetting', [
      'set_notice_by_app',
      'set_notice_by_mail',
      'set_msg_notice_from_favo',
      'set_msg_notice_from_site',
      'set_msg_notice_from_fuzai',
      'set_msg_notice_from_iine'
      // 'set_app_notice_vib',
      // 'set_app_notice_sound'
    ]),

    /**
     * iOS のアプリのみプッシュ通知が許可されているかチェック
     */
    async hasPermissionToPushNotification(this: any) {
      if (!this.$_platformIsIOS) {
        return
      }
      const isEnabled = await push.hasPermissionPushNotification()
      push.initPushNotification(this.$root)
      this.disabledPushNotification = !isEnabled
    },

    /**
     * 設定アプリの通知を開く
     */
    async openNativePushSetting(this: any) {
      try {
        await this.$_openNativeSettings('notification_id')
      } catch (err) {
        console.error(err)
      }
    },

    onSubmit(this: any) {
      if (!this.initialized) {
        return
      }
      try {
        this.$http.post('/notice_setting/', {
          page: 'save',
          notice_by_app: this.isNotifyApp,
          // notice_by_mail: this.myEmail
          msg_notice_from_favo: this.isFavOnry,
          msg_notice_from_site: this.isInfomation,
          msg_notice_from_fuzai: this.isMissedCalls,
          msg_notice_from_iine: this.isIine
          // app_notice_sound: this.isSound,
          // app_notice_vib: this.isVibration
        })
        this.set_notice_by_app(this.isNotifyApp)
        // this.set_notice_by_mail(this.myEmail)
        this.set_msg_notice_from_favo(this.isFavOnry)
        this.set_msg_notice_from_site(this.isInfomation)
        this.set_msg_notice_from_fuzai(this.isMissedCalls)
        this.set_msg_notice_from_iine(this.isIine)
        // this.set_app_notice_sound(this.isSound)
        // this.set_app_notice_vib(this.isVibration)
        this.$router.back()
      } catch (err) {
        this.$_alert(err)
      }
    },

    /**
     * isNotifyApp が 1 じゃない旨をアラートする
     */
    checkNotifyApp(this: any) {
      if (this.isNotifyApp !== 1) {
        this.$_alert('アプリで通知を ON にしてください')
      }
    }
  }
})
